import { ReflectionParams } from '../models';

export const createKey = (id: string, params?: ReflectionParams): string =>
    `${id}:${params?.pathwayId ?? ''}:${params?.courseId ?? ''}:${params?.moduleId ?? ''}`;
